let socket = null;

/**
 * pc端菜单(DsfHome)、快捷菜单(DsfNavMenu、DsfConvenientMenu)、和移动端的九宫格(DsfMobileNavMenu、DsfMobileConvenientMenu) 角标
 */
const cornerMark = {
  namespaced: true,
  state: {
    badges: {},
    menuIds:[]
  },
  mutations: {
    updateBadges(state, opts) {
      let menus = opts.data,
        objs = {};
      _.forEach(menus, (obj) => {
        objs[obj.menuId] = obj
      })
      if (menus?.length) {
        state.badges = {
          ...state.badges,
          ...objs
        }
      }
    },
    updateMenuIds(state,newIds){
      state.menuIds = _.uniq([...state.menuIds,...newIds]);
    }
  },
  actions: {
    init({ commit }, opts) {
      if(+dsf.config.setting_public_ws_switch){
        socket = dsf.ws(dsf.config.setting_public_ws_url || "ws://"+location.hostname+":8888");
        commit('updateMenuIds', opts.menu_ids);
        socket.$on('/menu/cornerMark', {markId: opts.markId.join(",")}, ({ data }) => {
          commit('updateBadges', { data, type: opts.type });
        });
        socket.$send('/menu/cornerMark',opts.menu_ids.join(","),{
          queryParams:{markId: opts.markId.join(",")}
        }, true);
        // if (!socket){
        //   socket = dsf.ws(dsf.config.setting_public_ws_url || "ws://"+location.hostname+":8888", {
        //     open: () => {
        //       fn()
        //     }
        //   });
        // }else{
        //   fn()
        // }
        // function fn(){
        //   commit('updateMenuIds', opts.menu_ids);
        //   socket.$on('/menu/cornerMark', {markId: opts.markId.join(",")}, ({ data }) => {
        //     commit('updateBadges', { data, type: opts.type });
        //   },true);
        //   socket.$send('/menu/cornerMark',opts.menu_ids.join(","),{
        //     queryParams:{markId: opts.markId.join(",")}
        //   });
        // }
      }
    }
  },
  getters: {}
}

export default cornerMark;